import { ChangeDetectorRef, Component, Inject, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from '../../services/AccountService';
import { MatSelectionList } from '@angular/material/list';
import { Preset } from '../../models/preset';
import { CustomEmailValidator } from '../../theme/utils/app-validators';

@Component({ standalone:false,
  selector: 'app-edit-preset-defaults-dialog',
  templateUrl: './edit-preset-defaults-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./edit-preset-defaults-dialog.component.scss']
})
export class EditPresetDefaultsDialogComponent {
  public title: string = "Edit preset defaults"
  public cancelButtonText = "CANCEL";
  public submitButtonText = "SAVE CHANGES";
  public deleteButtonText = "DELETE";
  public namesTaken:string[] = [];
  public presets:Preset[] =[];

  public presetDefaultsForm:FormGroup;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<EditPresetDefaultsDialogComponent>, private accService:AccountService, private cdRef:ChangeDetectorRef) {
    this.presets=data.presets;
     this.presetDefaultsForm = new FormGroup({
      presets: new FormArray([])
    });
  }

  ngOnInit() {
    this.populateForm();
  }

  private populateForm(){
    this.addPresets(this.presets);
  }

  get presetsArray(): FormGroup[] {
    return (this.presetDefaultsForm.get('presets') as FormArray).controls as FormGroup[];
  }

  get canSubmit(){
    return this.presetDefaultsForm.valid && this.presetDefaultsForm.dirty;
  }
  
  public onBooleanPresetChanged(parameter:FormGroup, $event:any){
    parameter.get("value")!.setValue($event.checked?'true':'false')
    parameter.markAsDirty();
  }

  public addPresets(presets:Preset[]){
    if(presets.length>0){
      const fa = this.presetDefaultsForm.get('presets') as FormArray;
      presets.forEach(ps=>{
        let parameter=this.createPreset(ps.name, ps.inputType, ps.defaultValue);
        fa.push(parameter);
      });
    }
  }

  public createPreset(name:string, inputType:string, value:string): FormGroup{
    let fbGroup = new FormGroup({
      name:new FormControl<string>(name),
      value:new FormControl<string>(value?value:''),
      inputType:new FormControl<string>(inputType),
    });
    if(inputType=='eml') fbGroup.get('value')!.addValidators(CustomEmailValidator.isMultiValid);
    fbGroup.updateValueAndValidity();
    fbGroup.markAsPristine();
    return fbGroup;
  }

  public getPresetOptions(name:string){
      return this.presets.find(p=>p.name==name)?.options;
  }

  public onSubmitClick(): void {
    const fa = this.presetDefaultsForm.get("presets") as FormArray;
    const presetMap = new Map();
    fa.value.forEach((ps:any) => {
      presetMap.set(ps.name, ps.value);
      //this.presets.find(p=>p.name==ps.name).defaultValue=ps.value;
    });
    this.dialogRef.close(presetMap);
  }

  public onCancelClick(): void {
    this.dialogRef.close(undefined);
  }

}
